import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
// @ts-nocheck

import nameStorage from 'name-storage';
import { addEvent, getAttr, getValue, nodeListToArray, url, _storage as storage } from "../../utils";
var ALIPAYDOMAIN = '.alipay.com';
var refList = ['refUrl',
// 上个页面url
'srcSpm',
// 上个页面的spm，具体到d位
'referPageId',
// 上个页面的pageId,
'referSPM',
// 上个页面的spm，到b位
'dtLogMonitor' // 分佣标识
];

// 链路信息缓存key
var REF_PREFIX = 'TRACERT_REF_';
var FullfillRefspm = /*#__PURE__*/function () {
  function FullfillRefspm(tracert) {
    var _this = this;
    _classCallCheck(this, FullfillRefspm);
    this.tracert = tracert || {};
    this.isAlipayDomain = document.domain && document.domain.indexOf(ALIPAYDOMAIN) !== -1;
    this.cookiesDomain = this.isAlipayDomain ? ALIPAYDOMAIN : null;
    this.initRef();
    tracert.before('logPv', function () {
      // Todo 若click高于logPv先触发，存在设置错误问题，但这里后续考虑logPv先于click、expo的约定
      tracert.srcSpm = tracert.lastClkSpm || tracert.srcSpm;
    });

    // 注意：这里的Pv埋点代表页面开始
    tracert.after('logPv', function () {
      tracert.referSPM = _this.getPageSpmAB();
      tracert.referPageId = tracert.pageId;
      tracert.refUrl = tracert.url;
      tracert.srcSpm = tracert.lastClkSpm;
    });

    // 页面离开前缓存
    addEvent('beforeunload', window, function () {
      _this.cache();
    });
  }
  _createClass(FullfillRefspm, [{
    key: "getPageSpmAB",
    value: function getPageSpmAB(spmAPos, spmBPos) {
      var _spmAPos = spmAPos;
      var _spmBPos = spmBPos;
      if (!_spmAPos && !_spmBPos) {
        _spmAPos = this.tracert.spmAPos;
        _spmBPos = this.tracert.spmBPos;
      }
      if (_spmAPos && _spmBPos) {
        return "".concat(_spmAPos, ".").concat(encodeURIComponent(_spmBPos));
      }
      return '';
    }
  }, {
    key: "initRef",
    value: function initRef() {
      var tracert = this.tracert;
      // 历史兼容写法
      var refObj = {
        referSPM: this.getMetaSpmId() || ''
      };
      // 初始化链路信息，依次从url、nameStorage、cookie中获取
      var cache = this.get();
      refList.forEach(function (key) {
        var value = getValue(key);
        if (!value && !tracert.ignoreNameStorage) {
          value = nameStorage.getItem("".concat(REF_PREFIX).concat(key));
        }
        if (!value && cache) {
          value = cache[key];
        }
        // 如果存在 存入缓存
        if (value) {
          refObj[key] = value;
        }
      });
      tracert.call('set', refObj);
    }
  }, {
    key: "getMetaSpmId",
    value: function getMetaSpmId() {
      var _window, _window$document;
      var metaList = nodeListToArray((_window = window) === null || _window === void 0 ? void 0 : (_window$document = _window.document) === null || _window$document === void 0 ? void 0 : _window$document.getElementsByTagName('meta'));
      var metaSpmb = '';
      for (var i = 0; i < metaList.length; i++) {
        var metaItem = metaList[i];
        var name = getAttr(metaItem, 'name');
        var content = getAttr(metaItem, 'content');
        if (!content || !name) {
          continue;
        }
        switch (name) {
          case 'pagename':
            metaSpmb = content;
            break;
          default:
            break;
        }
      }
      if (metaSpmb) {
        return this.getPageSpmAB(this.tracert.spmAPos, metaSpmb);
      }
      return metaSpmb;
    }

    // 将点击的详细信息暂存到 cookie
  }, {
    key: "cache",
    value: function cache() {
      var tracert = this.tracert || {};
      var refUrl = location.href || '';
      // cookie 长度保护
      if (refUrl.length > 150) {
        refUrl = tracert.url;
      }
      var referSPM = this.getPageSpmAB();
      var srcSpm = tracert.lastClkSpm,
        referPageId = tracert.referPageId;
      var cacheArray = [refUrl,
      // 当前url
      referSPM,
      // referSPM
      srcSpm, referPageId || ''];
      storage.set('fullfill_ref', cacheArray.join("\x01"), {
        domain: this.cookiesDomain,
        cookie: true
      });

      // 兼容历史用法
      if (!tracert.ignoreNameStorage) {
        var cacheInfo = {
          refUrl: refUrl,
          referPageId: referPageId,
          referSPM: referSPM,
          srcSpm: srcSpm
        };
        Object.keys(cacheInfo).forEach(function (key) {
          if (cacheInfo[key]) {
            nameStorage.setItem("".concat(REF_PREFIX).concat(key), cacheInfo[key]);
          }
        });
      }
    }

    // 从 cookie 中获取最近一次点击的详情
  }, {
    key: "get",
    value: function get() {
      // 获取并清除
      var v = storage.get('fullfill_ref', {
        domain: this.cookiesDomain
      }, true);
      if (typeof v !== 'string') return null;
      var sliceArr = v.split("\x01");
      if (!sliceArr[0]) {
        return null;
      }
      var refUrl = sliceArr[0];
      var referSPM = sliceArr[1];
      var srcSpm = sliceArr[2];
      var referPageId = sliceArr[3];
      // 对比 refUrl 的 host 和 cookie中存的host
      var urlObj = url.parse(this.tracert.url || '');
      var lastUrlObj = url.parse(refUrl || '');
      // 如果相同 需要补全refSpm 和 refUrl
      if (lastUrlObj.host === urlObj.host) {
        return {
          refUrl: refUrl,
          referSPM: referSPM,
          srcSpm: srcSpm,
          referPageId: referPageId
        };
      }
      return null;
    }
  }]);
  return FullfillRefspm;
}();
export { FullfillRefspm as default };